import { CustomModalLayout, Modal, Text, Heading, Button, Box } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent } from 'react';

import { DATA_HOOKS } from '../../../../dataHooks';

import css from './index.module.scss';
export interface KeraAssistantPermissionModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const KeraAssistantPermissionModal: FunctionComponent<KeraAssistantPermissionModalProps> = ({
  isOpen,
  onCancel,
  onContinue,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL}
      isOpen={isOpen}
      onRequestClose={onCancel}
      scrollable={false}
      screen="desktop"
    >
      <CustomModalLayout
        dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL_BODY}
        width={480}
        onCloseButtonClick={onCancel}
        className={css.KeraAssistantPermissionModal}
        title={
          <Heading
            size="medium"
            dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL_TITLE}
          >
            {t('kera-assistant.permission-modal.title')}
          </Heading>
        }
        content={
          <Box direction="vertical" gap="24px">
            <Text
              size="medium"
              dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL_DESCRIPTION}
            >
              {t('kera-assistant.permission-modal.description')}
            </Text>
            <Box gap="12px" align="right">
              <Button
                dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL_CANCEL}
                onClick={onCancel}
                priority="secondary"
              >
                {t('kera-assistant.permission-modal.cancel')}
              </Button>
              <Button
                dataHook={DATA_HOOKS.KERA_ASSISTANT_PERMISSION_MODAL_CONTINUE}
                onClick={onContinue}
                skin='standard'
              >
                {t('kera-assistant.permission-modal.continue')}
              </Button>
            </Box>
          </Box>
        }
      />
    </Modal>
  );
};
